import { createContent } from '@altify/utils';

export const content = createContent({
  en: {
    noPausedRecurringBuys: 'You have no paused Recurring Buys',
  },
  de: {
    noPausedRecurringBuys: 'Du hast keine pausiert wiederkehrenden Käufe',
  },
});
